import { render, staticRenderFns } from "./DevDashboard.vue?vue&type=template&id=a2f4e7be&scoped=true"
import script from "./DevDashboard.vue?vue&type=script&lang=js"
export * from "./DevDashboard.vue?vue&type=script&lang=js"
import style0 from "./DevDashboard.vue?vue&type=style&index=0&id=a2f4e7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f4e7be",
  null
  
)

export default component.exports